import type { FastField, IgnoreField, PbDistanceMetres } from "@/lib/api/types";

export type PbDistance = {
  key: PbDistanceMetres;
  metres: number; // exact metres used for pace maths
  label: string;
  short: string;
  field: FastField;
  ignoreField: IgnoreField;
};

/** Canonical PB distance table (mirrors the server's fast_* columns). */
export const PB_DISTANCES: readonly PbDistance[] = [
  { key: 400, metres: 400, label: "400m", short: "400m", field: "fast_400", ignoreField: "ignore_400" },
  { key: 800, metres: 800, label: "800m", short: "800m", field: "fast_800", ignoreField: "ignore_800" },
  { key: 1000, metres: 1000, label: "1km", short: "1K", field: "fast_1000", ignoreField: "ignore_1000" },
  { key: 1609, metres: 1609.34, label: "1 mile", short: "1mi", field: "fast_1609", ignoreField: "ignore_1609" },
  { key: 3218, metres: 3218.69, label: "2 mile", short: "2mi", field: "fast_3218", ignoreField: "ignore_3218" },
  { key: 5000, metres: 5000, label: "5km", short: "5K", field: "fast_5000", ignoreField: "ignore_5000" },
  { key: 10000, metres: 10000, label: "10km", short: "10K", field: "fast_10000", ignoreField: "ignore_10000" },
  { key: 21097, metres: 21097.5, label: "Half Marathon", short: "HM", field: "fast_21097", ignoreField: "ignore_21097" },
  { key: 42195, metres: 42195, label: "Marathon", short: "M", field: "fast_42195", ignoreField: "ignore_42195" },
  { key: 50000, metres: 50000, label: "50km", short: "50K", field: "fast_50000", ignoreField: "ignore_50000" },
  { key: 100000, metres: 100000, label: "100km", short: "100K", field: "fast_100000", ignoreField: "ignore_100000" },
];

export const pbDistanceByKey = (key: number): PbDistance | undefined => PB_DISTANCES.find((d) => d.key === key);
